import { TaskListMini } from "@/pages/tasks/components/TaskListMini";

export function TasksTab({ id }: { id: string }) {
  return (
    <TaskListMini
      relatedEntityType="SpvPool"
      relatedEntityId={id}
      addButtonLabel="+ Add task"
    />
  );
}
